import styled from "styled-components";

export const WheelOfJackpotbetDefaultBox = styled.div<{wheelSize: number;}>`
    /** This creates a positioning context for all children with position: absolute to be rendered at the center */
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    /** other styles */
    width: ${props => props.wheelSize}px;
    height: ${props => props.wheelSize}px;
    box-sizing: content-box;

    /* Making sure the flapper has space */
    /* margin-top: 20px; */

    -webkit-user-select: none; /* Safari */
    user-select: none;
`;
